import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ModalController, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ReservationsServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationDomainsPage } from '../../../configuration/configuration-domains/configuration-domains';
import { ModalExtraInput } from '../../../components/modal-extra-input/modal-extra-input';
import { ConfigurationEstablishmentCreatePage } from '../../../configuration/configuration-establishment/configuration-establishment-create/configuration-establishment-create';
import { ConfigurationServices } from '../../../configuration/services';


@Component({
    selector: 'page-reservation-calendar-config',
    templateUrl: 'reservation-calendar-config.html',
})
export class ReservationCalendarConfigPage {
    @Input() reservation_config;

    horary_start: any = "";
    horary_end: any = "";
    horary_monday: boolean = false;
    horary_tuesday: boolean = false;
    horary_wednesday: boolean = false;
    horary_thursday: boolean = false;
    horary_friday: boolean = false;
    horary_saturday: boolean = false;
    horary_sunday: boolean = false;
    fields_default = [
        {
            active: true,
            name: this.translate.instant('general-comensales'),
            options: "",
            order: 0,
            required: true,
            type: "text"
        },
        {
            active: true,
            name: this.translate.instant('general-fecha'),
            options: "",
            order: 1,
            required: true,
            type: "date"
        },
        {
            active: true,
            name: this.translate.instant('general-hora'),
            options: "",
            order: 2,
            required: true,
            type: "time"
        },
        {
            active: true,
            name: this.translate.instant('general-nombre-completo'),
            options: "",
            order: 2,
            required: true,
            type: "text"
        },
        {
            active: true,
            name: this.translate.instant('login-correo-electronico'),
            options: "",
            order: 2,
            required: true,
            type: "email"
        }
    ];
    reservation_text_web: string = '';
    _reservation_text_web: string = '';
    privacy_policy: string = '';
    _privacy_policy: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices,
        public translate: TranslateService,
        public alertCtrl: AlertController,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public configurationServices: ConfigurationServices) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.getReservationInfo();
        this.getPrivacity();
    }

    getReservationInfo() {
        if (this.globals.restaurant.reservation_text_web != undefined) {
            this._reservation_text_web = this.globals.restaurant.reservation_text_web;
        } else {
            this._reservation_text_web = '';
        }
    }

    getPrivacity() {
        if (this.reservation_config.privacy_policy != undefined) {
            this._privacy_policy = this.reservation_config.privacy_policy;
        } else {
            this._privacy_policy = '';
        }
    }

    editDomain() {
        this.navCtrl.push(ConfigurationDomainsPage);
    }

    updateTitleSubtitle() {
        this.globals.GAtrackView('Reservations', 'Reservations - OnlineForm Title/Subtitle - Update', this.globals.restaurant.email, 'Create/Update', 'Update title/subtitle of online form', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_title: this.reservation_config.form_title,
            form_subtitle: this.reservation_config.form_subtitle
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    updatePersons() {
        this.globals.GAtrackView('Reservations', 'Reservations - Persons - Update', this.globals.restaurant.email, 'Create/Update', 'Update reservations persons', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_persons_min: this.reservation_config.form_persons_min,
            form_persons_max: this.reservation_config.form_persons_max
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    deleteHorary(index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('reservas-eliminar-horario'),
            message: this.translate.instant('reservas-eliminar-horario-desc'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.reservation_config.horary.splice(index, 1);
                        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
                            horary: this.reservation_config.horary
                        });
                        this.globals.GAtrackView('Reservations', 'Reservations - Horary - Delete', this.globals.restaurant.email, 'Delete', 'Delete reservations horary', 'Reservations', '');
                    }
                }
            ]
        });
        alert.present();
    }

    addHorary() {
        //Comprovar que se hayan añadido las horas, y seleccionado minimo 1 dia
        if (this.horary_start != "" && this.horary_end != "" && (this.horary_monday || this.horary_tuesday || this.horary_wednesday || this.horary_thursday || this.horary_friday || this.horary_saturday || this.horary_sunday)) {
            document.getElementById('horary_error').classList.add('d-none');
            if (!this.reservation_config.horary) {
                this.reservation_config.horary = [];
            }
            this.reservation_config.horary.push({
                start: this.horary_start,
                end: this.horary_end,
                monday: this.horary_monday,
                tuesday: this.horary_tuesday,
                wednesday: this.horary_wednesday,
                thursday: this.horary_thursday,
                friday: this.horary_friday,
                saturday: this.horary_saturday,
                sunday: this.horary_sunday
            });
            this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
                horary: this.reservation_config.horary
            });
            this.horary_start = "";
            this.horary_end = "";
            this.horary_monday = false;
            this.horary_tuesday = false;
            this.horary_wednesday = false;
            this.horary_thursday = false;
            this.horary_friday = false;
            this.horary_saturday = false;
            this.horary_sunday = false;
            this.globals.GAtrackView('Reservations', 'Reservations - Horary - Create', this.globals.restaurant.email, 'Create/Update', 'Add new reservation horary', 'Reservations', '');
        } else {
            document.getElementById('horary_error').classList.remove('d-none');
        }
    }

    updateStripes() {
        this.globals.GAtrackView('Reservations', 'Reservations - Stripes - Update', this.globals.restaurant.email, 'Create/Update', 'Update reservations stripes', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_stripes: this.reservation_config.form_stripes
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    updateInterval() {
        this.globals.GAtrackView('Reservations', 'Reservations - Interval - Update', this.globals.restaurant.email, 'Create/Update', 'Update reservations interval', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_time_interval: this.reservation_config.form_time_interval
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    updateFields() {
        this.globals.GAtrackView('Reservations', 'Reservations - FormOnline Fields - Update', this.globals.restaurant.email, 'Create/Update', 'Update fields of form online', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_inputs_default: this.reservation_config.form_inputs_default
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    editField(index) {
        let profileModal = this.modalCtrl.create(ModalExtraInput, {
            input: this.reservation_config.form_inputs[index]
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                data.name = (data.name || '').trim();
                if (!data.name) {
                    this.toastCtrl.create({
                        message: this.translate.instant('general-introduce-todos-datos-obligatorios'),
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                    return;
                }
                data.input_name = this.globals.replaceSpecialChars(data.name).toLowerCase();
                if (!data.input_name) {
                    this.toastCtrl.create({
                        message: this.translate.instant('general-introduce-todos-datos-obligatorios'),
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                    return;
                }
                this.reservation_config.form_inputs[index] = data;
                this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
                    form_inputs: this.reservation_config.form_inputs
                });
                this.globals.GAtrackView('Reservations', 'Reservations - FormOnline Custom Field - Update', this.globals.restaurant.email, 'Create/Update', 'Update custom field of form online', 'Reservations', '');

            }
        });
        profileModal.present();
    }

    deleteField(index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('reservas-eliminar-campo-personalizado'),
            message: this.translate.instant('reservas-eliminar-campo-personalizado-desc'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.reservation_config.form_inputs.splice(index, 1);
                        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
                            form_inputs: this.reservation_config.form_inputs
                        });
                        this.globals.GAtrackView('Reservations', 'Reservations - FormOnline Custom Field - Delete', this.globals.restaurant.email, 'Delete', 'Delete custom field of form online', 'Reservations', '');
                    }
                }
            ]
        });
        alert.present();
    }

    reorderFields(indexes) {
        let element = this.reservation_config.form_inputs[indexes.from];
        this.reservation_config.form_inputs.splice(indexes.from, 1);
        this.reservation_config.form_inputs.splice(indexes.to, 0, element);
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_inputs: this.reservation_config.form_inputs
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    addCustomField() {
        let profileModal = this.modalCtrl.create(ModalExtraInput);
        profileModal.onDidDismiss(data => {
            if (data) {
                data.name = (data.name || '').trim();
                if (!data.name) {
                    this.toastCtrl.create({
                        message: this.translate.instant('general-introduce-todos-datos-obligatorios'),
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                    return;
                }
                data.input_name = this.globals.replaceSpecialChars(data.name).toLowerCase();
                if (!data.input_name) {
                    this.toastCtrl.create({
                        message: this.translate.instant('general-introduce-todos-datos-obligatorios'),
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                    return;
                }
                if (this.reservation_config.form_inputs == undefined) {
                    this.reservation_config.form_inputs = [];
                }
                this.reservation_config.form_inputs.push(data);
                this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
                    form_inputs: this.reservation_config.form_inputs
                });
                this.globals.GAtrackView('Reservations', 'Reservations - FormOnline Custom Field - Create', this.globals.restaurant.email, 'Create/Update', 'Add new custom field of form online', 'Reservations', '');
            }
        });
        profileModal.present();
    }

    setReservationInfo(editor) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.reservation_text_web = editor.html;
            } else {
                this.reservation_text_web = '';
            }
        }
    }

    updateReservationInfo() {
        this.globals.GAtrackView('Reservations', 'Reservations - FormOnline Add Info - Update', this.globals.restaurant.email, 'Create/Update', 'Update additional info in form online', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            reservation_text_web: this.reservation_text_web
        }).then(() => {
            this.globals.restaurant.reservation_text_web = this.reservation_text_web;
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    setPrivacity(editor) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.privacy_policy = editor.html;
            } else {
                this.privacy_policy = '';
            }
        }
    }

    updatePrivacity() {
        this.globals.GAtrackView('Reservations', 'Reservations - Privacy Policy - Update', this.globals.restaurant.email, 'Create/Update', 'Update privacy policy in form online', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            privacy_policy: this.privacy_policy
        }).then(() => {
            this.reservation_config.privacy_policy = this.privacy_policy;
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    updateAutoAccept() {
        this.globals.GAtrackView('Reservations', 'Reservations - AutoAccept - Update', this.globals.restaurant.email, 'Create/Update', 'Auto accept reservations', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            autoaccept: this.reservation_config.autoaccept
        });
    }

    updateMaxPersonsStripe() {
        this.globals.GAtrackView('Reservations', 'Reservations - AutoAccept Max Persons x Stripe - Update', this.globals.restaurant.email, 'Create/Update', 'Update autoaccept max persons per stripe', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            autoaccept_persons_max_per_stripe: this.reservation_config.autoaccept_persons_max_per_stripe
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    updateReservationShare() {
        this.globals.GAtrackView('Reservations', 'Reservations - Reservation In Share - Update', this.globals.restaurant.email, 'Create/Update', 'Update reservation in share', 'Reservations', '');
        this.reservationsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            reservation_in_share: this.globals.restaurant.reservation_in_share
        });
    }

    async editNotificationEmail() {
        var restaurant = await this.configurationServices.getRest(this.globals.restaurant_uid);
        this.globals.side_menu_config_active = "establishment";
        this.navCtrl.push(ConfigurationEstablishmentCreatePage, {
            update_state: true,
            restaurant: restaurant,
        });
        this.globals.open_side_menu = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-calendar/reservation-calendar-config/reservation-calendar-config.ts